module.exports = __webpack_public_path__ + "img/prev_speedy.d5731224.png";